import React, { ReactNode } from 'react';
// @ts-ignore
import styles from './DENTModalOverviewGeneralSection.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	title: string;
	actionButton?: ReactNode;
	children: ReactNode;
}

const DENTModalOverviewGeneralSection = ({
	title,
	actionButton,
	children,
}: Props) => {
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				<h2>{t(title)}</h2>
				{actionButton && actionButton}
			</div>
			{children}
		</div>
	);
};

export default DENTModalOverviewGeneralSection;
